import Icon from "../../icons";
import { FC } from "react";
import { OnToggleButtonClick } from "./handlers/OnToggleButtonClick";
import { IToggleProps } from "./types";
import Typography from "../../v2/typography";

interface IToggleButtonBoxProps {
  border?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
}

export const ToggleButtonBox: FC<IToggleButtonBoxProps> = ({ children, border, onClick }) => (
  <div
    onClick={onClick}
    className={`flex items-center self-center justify-center rounded-md px-2 my-3 h-9 transition-colors ease-in-out duration-300 ${
      border ? "border border-grey dark:border-blueBorderDark" : ""
    }
    hover:cursor-pointer hover:bg-blueHover dark:hover:bg-blueHoverDark
    `}
  >
    {children}
  </div>
);

export const ToggleButton = ({ inActiveText, activeText, expanded, setExpanded, border = true }: IToggleProps) => {
  const logo = !expanded ? "chevronDownIcon" : "chevronUpIcon";
  const buttonText = !expanded ? activeText : inActiveText;

  return (
    <ToggleButtonBox onClick={() => OnToggleButtonClick(expanded, setExpanded)} border={border}>
      <div className="flex px-2 justify-center">
        <Typography variant="DescriptionBold">{buttonText}</Typography>
      </div>
      <div className="flex items-center justify-center">
        <Icon name={logo} size="xxxsmall" />
      </div>
    </ToggleButtonBox>
  );
};
